<template>
  <div class="gridBox" style="background: #fff">
    <div class="tabContro van-hairline--bottom">
      <div class="tit">发票（1）</div>
      <div class="del">删除</div>
    </div>
    <div class="essentialInformation">
      <div>
        <div class="label">票据类型</div>
        <div class="text">123456</div>
      </div>
      <div>
        <div class="label">发票号码</div>
        <div class="text">王先生</div>
      </div>
      <div>
        <div class="label">发票代码</div>
        <div class="text">123456</div>
      </div>
      <div>
        <div class="label">不含税金额</div>
        <div class="text">岗位一</div>
      </div>
      <div>
        <div class="label">税率</div>
        <div class="text">公司一</div>
      </div>
      <div>
        <div class="label">税额</div>
        <div class="text">123456</div>
      </div>
      <div>
        <div class="label">价税合计</div>
        <div class="text">123456</div>
      </div>
      <div>
        <div class="label">本次报销金额</div>
        <div class="text">123456</div>
      </div>
      <div>
        <div class="label">说明</div>
        <div class="text">213213213213</div>
      </div>
    </div>
    <div class="add noCopy" onbeforecopy="return false">
      <van-button @click="jump"
        ><svg-icon
          icon-class="add"
          style="margin-right: 4px"
        />选择发票</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    jump() {
      this.$router.push({
        path: "/selectInvoice",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>